module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_2.3cf42586.jpg";